const { OAuth2Client } = require('google-auth-library')
// const josesss = require('jose')
// import jwt from 'jsonwebtoken'
/**
 * @description Function to decode Google OAuth token
 * @param token: string
 * @returns ticket objet
 */
export const getDecodedOAuthJwtGoogle = async token => {
  const CLIENT_ID_GOOGLE = '849421071823-7649e3vjt4595svhi5f9891a0l8h3l2e.apps.googleusercontent.com'
  try {
    const client = new OAuth2Client(CLIENT_ID_GOOGLE)
    const ticket = await client.verifyIdToken({
      idToken: token,
      audience: CLIENT_ID_GOOGLE,
    })
    return ticket
  } catch (error) {
    return { status: 500, data: error }
  }
}

export default getDecodedOAuthJwtGoogle